// extracted by mini-css-extract-plugin
module.exports = {"green":"TaskSeenIcon_green__sCFTL","grey":"TaskSeenIcon_grey__2KHzC","popup":"TaskSeenIcon_popup__1T9x1"};